import { inject, Injectable, Injector } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

// Types
import { FailedCall, TrialModeAndExecution } from '../../../shared/types/manageCalls';
import { UseTrialModeParams } from '../../../shared/types/params';

// Services
import { LoggerService } from '../../services/logger/logger.service';
import { OfflineService } from '../../services/offline/offline.service';
import { WebServiceCaller } from '../../services/webservice-caller/webservice-caller.service';

@Injectable()
export class TrialService {
  private readonly wsCaller = inject(WebServiceCaller);
  private readonly injector = inject(Injector);
  private readonly logger = inject(LoggerService);

  enableTrialMode(email: string): Observable<Record<string, unknown>> {
    return this.wsCaller.postCall<Record<string, unknown>>('appFunctions/generateEmailForEnableTrial', {
      email,
    });
  }

  useTrialMode(
    trialUsage: Array<UseTrialModeParams>,
    isFromCheckOfflineApis: boolean = false,
  ): Observable<{ result: string }> {
    type Response = { result: string };

    if (isFromCheckOfflineApis) {
      return this.wsCaller.postCall<Response>('useTrialMode', trialUsage);
    } else {
      return this.wsCaller.postCall<Response>('useTrialMode', trialUsage).pipe(
        catchError((error: FailedCall) => {
          this.logger.consoleError('TrialService', 'useTrialMode', { error });

          if (error === null || error?.code === 'CORS_ERROR') {
            const params = { timestampToUse: Date.now() };

            const offline = this.injector.get(OfflineService);
            offline.addApiToCallWhenOnline('useTrialMode', params);
          }
          return throwError(() => error);
        }),
      );
    }
  }

  trialModeAndExecution(): Observable<TrialModeAndExecution> {
    return this.wsCaller.postCall<TrialModeAndExecution>('trialModeAndExecution');
  }
}
